import React from 'react';
import { Messages, Control, Code, Name, Title, Actions, Form, Files, Toast, Button, API, Utility, useListContext, useCallback, useEffect, useState, Hooks } from 'helpers/ListImports';
import { Dispense } from 'models/DispenseModel';


const DispenseList: React.FC = () => {
  const width = { sno: 13, client:35, amount: 13,   date: 13, segment:13, createdby: 13 }
  const [formId, formName] = [Code.Form.Id.DISPENSE, Code.Form.Name.DISPENSE];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [dispenseData, setDispenseData] = useState<Dispense[]>([]); 
  const [selectedDispense, setselectedDispense] = useState<Dispense | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const triggers = [pno, rows, search, activeId, userId];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();
  
  Hooks.Privilege.HasView(Privilege);

  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.Dispense.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Dispense.Number, 
        Name.Dispense.Date, 
        Name.Client.FullName, 
        Name.Dispense.Net,
        Name.Common.SegmentName,
        Name.User.FullName,
      ]),
      user_id: userId,
      location_id: locationId,
    });
    await API.Data.List<Dispense>(url, setDispenseData, setError, setLoading); 
 }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId}  Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.User} options={userOptions} onChange={setUserId} />
              <Control.Dropdown title={Title.State} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, dispenseData, setSelectAllChecked,formName)} extra={2} />
              <Control.Grid.Items values={[
                [Title.DispenseNo, width.sno], 
                [Title.ClientName, width.client], 
                [Title.Amount, width.amount, Code.Align.RIGHT],
                [Title.Segment, width.segment],
                [Title.Date, width.date],
                [Title.CreatedBy, width.createdby]
              ]} last={1} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(dispenseData) && (
              <Control.Grid.Row>
                {dispenseData.map((dispenseData) => { return (
                  <Control.Grid.Data<Dispense> key={dispenseData.dispense_id} itemKey={dispenseData.dispense_key} data={dispenseData} setMenuPosition={setMenuPosition} setSelectedData={setselectedDispense} setShowMenu={setShowMenu}>
                    <Control.Grid.Check keyId={dispenseData.dispense_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                    <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, dispenseData.dispense_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Print path={Utility.Join.Print(Privilege, formName, dispenseData.dispense_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Text value={dispenseData.dispense_number} width={width.sno} />
                    <Control.Grid.Link value={Utility.Get.FullName(dispenseData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(Privilege, Code.Form.Name.CLIENT, dispenseData.client_id)} width={width.client} iframeRef={iframeRef}  />
                    <Control.Grid.Items values={[
                      [Utility.Format.Amount(dispenseData.dispense_net_amount), width.amount, Code.Align.RIGHT],
                      [dispenseData.segment_name, width.segment], 
                      [Utility.Format.DateOnly(dispenseData.dispense_date), width.date], 
                      [Utility.Get.FullName(dispenseData,Code.Form.Name.USER), width.createdby], 
                    ]} /> 
                    <Control.Grid.Actions>
                      <Control.Action.All formName={formName} activeId={activeId} keyId={dispenseData.dispense_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                    </Control.Grid.Actions>
                  </Control.Grid.Data>)})}
              </Control.Grid.Row>
            )}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={dispenseData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, `${formName}/${selectedDispense?.dispense_key}`)} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedDispense?.dispense_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default DispenseList;